// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetadataType } from './metadataType';
import type { ResourceMetadataCreateContent } from './resourceMetadataCreateContent';

/**
 * API Call to create a metadata instance
 */
export interface ResourceMetadataCreate {
  type: MetadataType;
  version: string;
  content: ResourceMetadataCreateContent;
}
